module.exports = __webpack_public_path__ + "img/ic-featured-active.ed4eb6b8.svg";